import React, { useMemo, ReactElement } from 'react';
import Table from '../../../../components/table/table.component';
import TableBody from '../../../../components/table-body/table-body.component';
import TableRow from '../../../../components/table-row/table-row.component';
import TableCell from '../../../../components/table-cell/table-cell.component';
import Widget from '../../../../components/widget/widget.component';
import CheckAccess from '../../../../components/check-access/check-access.component';
import FlexContainer from '../../../../components/flex-container/flex-container.component';
import FileListContainer from '../../../../components/file-list-container/file-list-container.component';
import FileLink from '../../../../components/file-link/file-link.component';
import { CONTACT_ATTACHMENT_LIST_VIEW } from '../../../../constants/entity/permissions';

const ContactWidgetDocuments: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const WIDGET_TITLE_DEFAULT: string = 'Documents';
  const WIDGET_NAME: string = 'widget-contact-documents';

  const {
    contactData,
  } = props;

  const isEmpty: boolean = !contactData || (!contactData.attachments || (contactData.attachments
    && !contactData.attachments.length));

  const contactAttachmentListViewPermissions: string[] = useMemo((): string[] => [CONTACT_ATTACHMENT_LIST_VIEW], []);

  return (
    <Widget
      isFullWidth
      isFullHeight
      isEmpty={isEmpty}
      widgetName={WIDGET_NAME}
      defaultWidgetTitle={WIDGET_TITLE_DEFAULT}
    >
      <Table>
        <TableBody isPlain withZebraRows>
          <CheckAccess permissions={contactAttachmentListViewPermissions}>
            <TableRow>
              <TableCell>
                Attachments
              </TableCell>
              <TableCell>
                <FileListContainer>
                  {
                    contactData.attachments.map((attachmentItem: Attachment): ReactElement => (
                      <FlexContainer isInline key={attachmentItem.id}>
                        <FileLink fileLink={attachmentItem.file} />
                      </FlexContainer>
                    ))
                  }
                </FileListContainer>
              </TableCell>
            </TableRow>
          </CheckAccess>
        </TableBody>
      </Table>
    </Widget>
  );
});

export default ContactWidgetDocuments;
